module.exports = __webpack_public_path__ + "img/server_connection_error.5a1ff0d4.svg";